import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import TableHeader from "components/common/Table/TableHeader";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { REPORTING_LIMIT, getParticipantLabel } from "Constants/constant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext } from "react";
import { addMonths, truncateTextReporting } from "Utils/utils";
import PaginationComponent from "components/common/Pagination/index";
import moment from "moment";
import CheckBox from "components/common/checkBox/checkbox";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "pages/Reporting/reportFilterUi";

const NDISClaimsReportsPresenter = ({
  handleFileDownLoad,
  handleSearch,
  handleClearFilters,
  loader,
  loading,
  participantList,
  selectedParticipant,
  setSelectedParticipant,
  setFromDate,
  setToDate,
  fromDate,
  toDate,
  selectedFromDate,
  setSelectedFromDate,
  page,
  setPage,
  fetchListReports,
  data,
  toggleCheckboxes,
  allSelected,
  checkboxes,
  setCheckboxes,
  setAllSelected,
  paginationObj,
  setPaginationObj,
  handleCheckboxChange,
  flipSort,
  sortBy,
  sortDescending,
  setData,
  settings,
  isDisableSearch,
  setIsDisableSearch,
  QueuedModal,
}) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const participantNameLabel = getParticipantLabel(settings?.care_sector, false) + " Name";

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={
          sideBarPadding
            ? "lg:pl-[4rem] duration-300 flex flex-col"
            : "lg:pl-64 duration-300 flex flex-col"
        }
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='NDIS Claims Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.NDIS_CLAIM_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={2}>
                <ReportFilterField label={participantNameLabel}>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='pt_id'
                    isSearch={true}
                    isDisabled={loader || false}
                    loading={loader || false}
                    data={participantList || []}
                    isMulti
                    selectedOption={selectedParticipant}
                    handleChange={(e) => setSelectedParticipant(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Date Range (Max 3 Months)' required>
                  <DateRangePickerNew
                    isDisabled={loader}
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                      setData([]);
                    }}
                    handleChange={(obj) => {
                      if (obj) {
                        obj.fromDate && setFromDate(obj.fromDate);
                        obj.toDate && setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={addMonths(selectedFromDate, 3)}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loading}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
                isOnlyExcel
              />
            </ReportFiltersShell>
            <ReportTableSection>
              <table className='border min-w-full divide-y divide-gray-300 mt-1'>
                <thead className='bg-gray-50 sticky z-[5]'>
                  <tr>
                    <th
                      scope='col'
                      className='pl-3 text-center text-sm font-semibold bg-blue-50'
                    >
                      <CheckBox
                        checked={allSelected}
                        handleChange={(e) => {
                          if (data?.length > 0) {
                            setAllSelected(e);
                            toggleCheckboxes(e);
                          }
                        }}
                      />
                    </th>
                    <TableHeader
                      sortName='participant_name'
                      flipSort={flipSort}
                      sortBy={sortBy}
                      sortDescending={sortDescending}
                      label={participantNameLabel}
                      cssClass='bg-blue-50 px-4'
                    />
                    <TableHeader
                      isSort={false}
                      label={"Start Time"}
                      cssClass='bg-blue-50 px-0'
                    />
                    <TableHeader
                      isSort={false}
                      label={"End Time"}
                      cssClass='bg-blue-50 px-0'
                    />
                    <TableHeader
                      isSort={false}
                      label={"Shift Ratio"}
                      cssClass='bg-blue-50 px-0'
                    />
                    <TableHeader
                      sortName='delivered_date'
                      flipSort={flipSort}
                      sortBy={sortBy}
                      sortDescending={sortDescending}
                      label={"Date Delivered"}
                      cssClass='bg-blue-50 px-0'
                    />
                  </tr>
                </thead>
                <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                  {loading ? (
                    <tr>
                      <td colSpan={6} className='text-center p-4'>
                        <CircularLoader />
                      </td>
                    </tr>
                  ) : data?.length > 0 ? (
                    data?.map((item, index) => (
                      <tr key={index} className='hover:bg-gray-100'>
                        <td className='whitespace-nowrap pl-3 py-4 text-sm text-gray-500'>
                          <div className='text-gray-500'>
                            <CheckBox
                              handleChange={(e) =>
                                handleCheckboxChange(e, item?.uuid)
                              }
                              checked={checkboxes?.indexOf(item?.uuid) !== -1}
                            />
                          </div>
                        </td>
                        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize'>
                          {truncateTextReporting(
                            Object.values(item?.participants) || "",
                            30
                          )}
                        </td>
                        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                          {item?.shift_start_time
                            ? moment(item?.shift_start_time).format(
                                "DD/MM/YYYY hh:mm A"
                              )
                            : "-"}
                        </td>
                        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                          {item?.shift_end_time
                            ? moment(item?.shift_end_time).format(
                                "DD/MM/YYYY hh:mm A"
                              )
                            : "-"}
                        </td>
                        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                          {item?.ratio || "-"}
                        </td>
                        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                          {item?.delivered_date
                            ? moment(item?.delivered_date).format("DD/MM/YYYY")
                            : "-"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={6}
                        className='text-center p-4 text-red-500'
                      >
                        No data found. Please adjust your filters to get
                        relevant results
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {data?.length !== 0 && (
                <PaginationComponent
                  page={page || 1}
                  activeListLength={data || []}
                  limit={REPORTING_LIMIT}
                  totalList={paginationObj?.total}
                  handlePagination={(e) => {
                    setPage(e);
                    fetchListReports(null, null, null, e);
                    const obj = paginationObj;
                    obj.page = e;
                    setPaginationObj({ ...obj });
                  }}
                  totalPages={paginationObj?.totalPages}
                />
              )}
            </ReportTableSection>
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default NDISClaimsReportsPresenter;
